angular.module('dental')
	.directive('code', function () {
		return {
			restrict: 'A',
			require: '?ngModel',
			link: function ($scope, $element, $attrs, ngModel) {
				$element.on('keypress', function (ev) {
					if (ev.key) {
						var number = parseInt(ev.key);
						if (!_.isNumber(number) || isNaN(number)) {
							ev.preventDefault();
						}
					} else if (ev.keyCode < 48 || ev.keyCode > 57 && ev.keyCode < 96 || ev.keyCode > 105) {
						ev.preventDefault();
					}
				});
				$element[0].addEventListener('paste', function (ev) {
					var value = (ev.clipboardData || window.clipboardData).getData('text');
					if (!/\d+/.test(value)) {
						ev.preventDefault();
					}
				});
				if (ngModel) {
					ngModel.$parsers.push(value => {
						let parsedVal = parseInt(value);
						return !_.isNumber(parsedVal) || isNaN(parsedVal) ? '' : value;
					});
				}
			}
		};
	});